module.exports = __webpack_public_path__ + "72ca728a17ad811a2c2cedf308fe669a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/logo/bird-colored.svg
// module id = ./app/images/logo/bird-colored.svg
// module chunks = 35